import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'VehicleOption',
		endpoint: '/vehicle/option',
        items: [],
    },
    actions: {
		load (context, params) {
			return axios.get(`/vehicle/generation/${params.generation.id}/modification`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}